import React, { Component } from 'react';
import { inject, observer } from 'mobx-react/index';
import { Spin, Icon, Row, Col, Card } from 'antd';
@inject('store')
@observer
export class CoinStatusPanel extends Component {
    render() {
        const record = this.props.record;

        if (!this.props.store.botStore.tickersStore.tickers || !record) {
            return <Spin />;
        }

        const ticker = this.props.store.botStore.tickersStore.tickers[
            `${record.baseId}${record.quoteId}`
        ];

        if (!ticker) return <div style={{ textAlign: 'center' }} />;

        const color = ticker.percent_change < 0 ? '#ff3366' : '#29c0b1';
        const arrow = ticker.percent_change < 0 ? 'arrow-down' : 'arrow-up';

        let url = `https://uk.tradingview.com/chart?symbol=binance%3A${record.baseId}${
            record.quoteId
        }`;
        if (this.props.store.botStore.currentConfiguration.exchange === 'kucoin') {
            url = `https://www.kucoin.com/trade/${record.baseId}-${record.quoteId}`;
        }

        return (
            <Card
                bordered={false}
                title={
                    <span onClick={() => window.open(url, '_blank')}>
                        {record.baseId}/{record.quoteId}{' '}
                    </span>
                }
                style={{ marginBottom: 15 }}
                size={'small'}
                extra={
                    <div style={{ position: 'absolute', right: 44, top: 6, fontSize: 18, color }}>
                        <Icon type={arrow} /> {ticker.last.toFixed(8)}{' '}
                        {ticker.percent_change.toFixed(2)}%
                    </div>
                }
            >
                <Row gutter={24}>
                    <Col md={12}>
                        <b>Bid:</b> {ticker.bid.toFixed(8)}
                    </Col>
                    <Col md={12}>
                        <b>Ask:</b> {ticker.ask.toFixed(8)}
                    </Col>
                    <Col md={12}>
                        <b>Open:</b> {ticker.open ? ticker.open.toFixed(8) : '-'}
                    </Col>
                    <Col md={12}>
                        <b>High:</b> {ticker.high.toFixed(8)}
                    </Col>
                    <Col md={12}>
                        <b>Low:</b> {ticker.low.toFixed(8)}
                    </Col>
                    <Col md={12}>
                        <b>Close:</b> {ticker.last.toFixed(8)}
                    </Col>
                    <Col md={12}>
                        <b>Volume:</b> {ticker.quote_volume} {this.props.quote}
                    </Col>
                </Row>
            </Card>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Account/Bot/PositionsView/CoinStatusPanel.js